// extracted by mini-css-extract-plugin
module.exports = {"value":"DashboardContent_value__Vc5ND","footer":"DashboardContent_footer__3Dsxw"};